import { Hidden, Step, StepLabel, Stepper, withStyles } from '@material-ui/core';
import React from 'react';
import CustomStepConnector from './CustomStepConnector/CustomStepConnector';
import StepIcon from './CustomStepIcon/CustomStepIcon';
var CustomStepLabel = withStyles(function () { return ({
    alternativeLabel: {
        '&$completed': {},
        '&$active': {
            color: 'var(--primario-morado)',
            fontWeight: 700,
        },
    },
    active: {},
    completed: {},
}); })(StepLabel);
var CustomSteper = function (_a) {
    var activeStep = _a.activeStep, steps = _a.steps, className = _a.className, stepNames = _a.stepNames;
    return (React.createElement(React.Fragment, null,
        React.createElement(Hidden, { only: ['xs', 'sm'] },
            React.createElement(Stepper, { className: className, alternativeLabel: true, activeStep: activeStep, connector: React.createElement(CustomStepConnector, null) }, steps.map(function (label, index) { return (React.createElement(Step, { key: label }, stepNames ? React.createElement(CustomStepLabel, null, stepNames[index]) : React.createElement(CustomStepLabel, { StepIconComponent: StepIcon }))); }))),
        React.createElement(Hidden, { only: ['md', 'lg', 'xl'] },
            React.createElement(Stepper, { className: className, alternativeLabel: true, activeStep: activeStep, connector: React.createElement(CustomStepConnector, null) }, steps.map(function (label) { return (React.createElement(Step, { key: label }, stepNames ? React.createElement(CustomStepLabel, null, null) : React.createElement(CustomStepLabel, { StepIconComponent: StepIcon }))); })))));
};
CustomSteper.defaultProps = {
    className: '',
    stepNames: [''],
};
export default CustomSteper;
